module.exports = __webpack_public_path__ + "media/images/img/11561923_35B-ec98b997bd97ffea2037bc531d5b73b7.jpg";